<template>
    <div class="mt-3 text-center">
        <span class="mt-2">Loading data</span>
        <v-progress-linear
            indeterminate
            color="#FB7E42"
        ></v-progress-linear>
    </div>
</template>

<script>
export default {
    name: "FieldDataLoading",
    props: {}
}
</script>

<style scoped>

</style>